import type { CampaignLevel, CampaignTypes, ICampaignResources } from '../campaignShared.types';

export const REBATE_CAMPAIGN_TYPE: Extract<CampaignTypes, 'rebate'> = 'rebate';
// fallow-ignore-next-line unused-export
export const REBATE_DISPLAY_NAME = 'Rebate';

export enum RebateStatuses {
  PROMO = 'PROMO',
  ACTIVE = 'ACTIVE',
  COMPLETED_VISIBLE = 'COMPLETED_VISIBLE',
};

/** Priority order shared across rebate campaigns */
export const REBATE_STATUS_ORDER: Record<RebateStatuses, number> = {
  [RebateStatuses.ACTIVE]: 1,
  [RebateStatuses.PROMO]: 2,
  [RebateStatuses.COMPLETED_VISIBLE]: 3
};

export interface IRebateResources extends ICampaignResources {
  CampaignsMultiViewPlate?: string;
}

export interface IUserProgress {
  spentBetAmount: number;
  levelProgress: number;
  claimedWin: number;
  totalWinAmount: number; // TODO_Rebate: Remove the property, as it is no longer needed.
}

export interface ICashbackLevel {
  levelNumber: number;
  betRangeFrom: number;
  betRangeTo: number;
  rebatePercent: number;
  maxPayoutAmount: number;
}

export interface IRebateCampaign {
  id: string;
  name: string;
  terms: string;
  status: RebateStatuses;
  startDate: string;
  endDate: string;
  visibleEndDate: string;
  prizeFund: number; // sum of all cashback levels' maxPayoutAmount — the overall max win amount for the current rebate campaign
  level: CampaignLevel;
  games: string[];
  minStake: number;
  baseCurrency: string;
  joined: boolean;
  resources: IRebateResources;
  minPayoutAmount: number; // TODO_Rebate: Remove the property, as it is no longer needed.
  minWinBetAmount: number; // TODO_Rebate: Remove the property, as it is no longer needed.
  userProgress: IUserProgress | null;
  cashbackLevels: ICashbackLevel[];
  type: Extract<CampaignTypes, 'rebate'>;
}
